import React from "react";
import { SpinnerContainer } from "./SpinnerStyled";

export default function Spinner() {
    return (
        <SpinnerContainer>
            <div className="loader">Loading...</div>
        </SpinnerContainer>
    )
}